/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.avatars.rpc.AvatarsRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type AvatarOverrideResponse = { avatar: Avatar };

export type ClearAvatarOverrideRequest = {
  sourceId: string;
  objectTypeAndId: ObjectTypeAndId;
};

export type SetAvatarOverrideRequest = {
  sourceId: string;
  imageData: string;
  objectTypeAndId: ObjectTypeAndId;
};

export type AvatarFromObjectId = {
  fileManagerKey?: string;
  knownPropertyValue?: KnownPropertyValue;
  objectTypeAndId: ObjectTypeAndId;
};

export const AvatarIdIdentifierTypename =
  'com.hubspot.avatars.models.resolver.AvatarIdIdentifier';
export const AvatarIdIdentifierDiscriminant = 'objectId';
export const AvatarIdIdentifierDiscriminantKey = 'identifierType';
export type AvatarIdIdentifier = {
  fileManagerKey?: string;
  knownPropertyValue?: KnownPropertyValue;
  objectTypeAndId: ObjectTypeAndId;
  __typename: 'com.hubspot.avatars.models.resolver.AvatarIdIdentifier';
} & { identifierType?: 'objectId' };

export const AvatarIdentifierDiscriminantKey = 'identifierType';
export type AvatarIdentifier =
  | AvatarIdIdentifier
  | AvatarUniquePropertyIdentifier;

export const AvatarUniquePropertyIdentifierTypename =
  'com.hubspot.avatars.models.resolver.AvatarUniquePropertyIdentifier';
export const AvatarUniquePropertyIdentifierDiscriminant = 'uniqueProperty';
export const AvatarUniquePropertyIdentifierDiscriminantKey = 'identifierType';
export type AvatarUniquePropertyIdentifier = {
  objectTypeId: string;
  knownPropertyValue: KnownPropertyValue;
  __typename: 'com.hubspot.avatars.models.resolver.AvatarUniquePropertyIdentifier';
} & { identifierType?: 'uniqueProperty' };

export type AvatarsByIdResponse = {
  avatarsByObjectTypeAndIdString: Default<Record<string, Avatar>>;
};

export type AvatarsByIdentifierResponse = {
  avatarsByIdentifier: Default<Record<string, Avatar>>;
};

export type AvatarsByUniquePropertyResponse = {
  avatarsByObjectTypeIdString: Default<Record<string, Record<string, Avatar>>>;
};

export type HubspotUserAvatarsResponse = {
  avatars: Default<Record<string, Avatar>>;
};

export type ResolveAvatarsByIdRequest = {
  avatarRequests: Default<AvatarFromObjectId[]>;
  size?: AvatarSize;
  trellisDefault: Default<boolean>;
};

export type ResolveAvatarsByIdentifierRequest = {
  identifiers: Default<AvatarIdentifier[]>;
  size?: AvatarSize;
  trellisDefault: Default<boolean>;
};

export type ResolveAvatarsByUniquePropertyRequest = {
  uniquePropertyKeys: Default<UniquePropertyKey[]>;
  size?: AvatarSize;
  trellisDefault: Default<boolean>;
};

export type ResolveHubspotUserAvatarsRequest = {
  userEmails: Default<string[]>;
  size?: AvatarSize;
  trellisDefault: Default<boolean>;
};

export type Avatar = { uri: string; source: AvatarSource };

export type AvatarSize =
  | 'SIZE_16'
  | 'SIZE_48'
  | 'SIZE_64'
  | 'SIZE_72'
  | 'SIZE_75'
  | 'SIZE_96'
  | 'SIZE_140'
  | 'SIZE_144'
  | 'SIZE_200'
  | 'SIZE_216'
  | unhandledEnumCase;

export type AvatarSource =
  | 'DEFAULT'
  | 'OVERRIDE'
  | 'ENRICHMENT'
  | 'INHERITED_OVERRIDE'
  | 'INHERITED_ENRICHMENT'
  | 'HUBSPOT_USER'
  | unhandledEnumCase;

export type KnownPropertyValue = {
  propertyName: string;
  propertyValue: string;
};

export type UniquePropertyKey = {
  objectTypeId: string;
  knownPropertyValue: KnownPropertyValue;
};

export type AvatarsErrorType =
  | 'MISSING_PORTAL_ID'
  | 'MISSING_USER_ID'
  | 'UNSUPPORTED_OBJECT_TYPE'
  | 'INVALID_PROPERTY_NAME'
  | 'AVATAR_FILE_UPLOAD_USER_ERROR'
  | 'PERMISSION_DENIED'
  | 'IMAGE_TOO_LARGE'
  | 'UNSUPPORTED_IMAGE'
  | unhandledEnumCase;

export type AvatarsRpcError = {
  errorType: AvatarsErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type GenerateHubspotUserSignedUriRequest = {
  userEmail: string;
  size?: AvatarSize;
  trellisDefault: Default<boolean>;
};

export type GenerateSignedUriByIdRequest = {
  fileManagerKey?: string;
  knownPropertyValue?: KnownPropertyValue;
  size?: AvatarSize;
  trellisDefault: Default<boolean>;
  objectTypeAndId: ObjectTypeAndId;
};

export type GenerateSignedUriByUniquePropertyRequest = {
  uniquePropertyKey: UniquePropertyKey;
  size?: AvatarSize;
  trellisDefault: Default<boolean>;
};

export type SignedAvatarUri = { value: string };

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type ObjectTypeAndId = { objectTypeId: string; objectId: number };

export type ResolveAvatarsByIdRequestType =
  Requestify<ResolveAvatarsByIdRequest>;
export type ResolveAvatarsByIdResponseType = AvatarsByIdResponse;
export type ResolveAvatarsByIdErrorType = AvatarsRpcError & HubspotMetadata;
export const resolveAvatarsByIdRpc: ChirpAvroRpcDetails<
  ResolveAvatarsByIdRequestType,
  ResolveAvatarsByIdResponseType,
  ResolveAvatarsByIdErrorType,
  false
> = {
  serviceName: 'com.hubspot.avatars.rpc.AvatarsRpc',
  rpcName: 'resolveAvatarsById',
  auth: 'app',
  fingerprint: 'aqRfEKrChVkK_Yyg1kepDj5RieILNF9x',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type ResolveAvatarsByUniquePropertyRequestType =
  Requestify<ResolveAvatarsByUniquePropertyRequest>;
export type ResolveAvatarsByUniquePropertyResponseType =
  AvatarsByUniquePropertyResponse;
export type ResolveAvatarsByUniquePropertyErrorType = AvatarsRpcError &
  HubspotMetadata;
export const resolveAvatarsByUniquePropertyRpc: ChirpAvroRpcDetails<
  ResolveAvatarsByUniquePropertyRequestType,
  ResolveAvatarsByUniquePropertyResponseType,
  ResolveAvatarsByUniquePropertyErrorType,
  false
> = {
  serviceName: 'com.hubspot.avatars.rpc.AvatarsRpc',
  rpcName: 'resolveAvatarsByUniqueProperty',
  auth: 'app',
  fingerprint: 'b2bbo9tJCAoA95zYAZg3WD5RieILNF9x',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type ResolveAvatarsByIdentifierRequestType =
  Requestify<ResolveAvatarsByIdentifierRequest>;
export type ResolveAvatarsByIdentifierResponseType =
  AvatarsByIdentifierResponse;
export type ResolveAvatarsByIdentifierErrorType = AvatarsRpcError &
  HubspotMetadata;
export const resolveAvatarsByIdentifierRpc: ChirpAvroRpcDetails<
  ResolveAvatarsByIdentifierRequestType,
  ResolveAvatarsByIdentifierResponseType,
  ResolveAvatarsByIdentifierErrorType,
  false
> = {
  serviceName: 'com.hubspot.avatars.rpc.AvatarsRpc',
  rpcName: 'resolveAvatarsByIdentifier',
  auth: 'app',
  fingerprint: 'D0Fr_TG8OdFqv6J76RZKmD5RieILNF9x',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type ResolveHubspotUserAvatarsRequestType =
  Requestify<ResolveHubspotUserAvatarsRequest>;
export type ResolveHubspotUserAvatarsResponseType = HubspotUserAvatarsResponse;
export type ResolveHubspotUserAvatarsErrorType = AvatarsRpcError &
  HubspotMetadata;
export const resolveHubspotUserAvatarsRpc: ChirpAvroRpcDetails<
  ResolveHubspotUserAvatarsRequestType,
  ResolveHubspotUserAvatarsResponseType,
  ResolveHubspotUserAvatarsErrorType,
  false
> = {
  serviceName: 'com.hubspot.avatars.rpc.AvatarsRpc',
  rpcName: 'resolveHubspotUserAvatars',
  auth: 'app',
  fingerprint: 'mYYb7y78RsSW1B6ow9z0Aj5RieILNF9x',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type SetAvatarOverrideRequestType = Requestify<SetAvatarOverrideRequest>;
export type SetAvatarOverrideResponseType = AvatarOverrideResponse;
export type SetAvatarOverrideErrorType = AvatarsRpcError & HubspotMetadata;
export const setAvatarOverrideRpc: ChirpAvroRpcDetails<
  SetAvatarOverrideRequestType,
  SetAvatarOverrideResponseType,
  SetAvatarOverrideErrorType,
  false
> = {
  serviceName: 'com.hubspot.avatars.rpc.AvatarsRpc',
  rpcName: 'setAvatarOverride',
  auth: 'app',
  fingerprint: 'wQZmhEFGh-Vxmk2FZ3nHzj5RieILNF9x',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type ClearAvatarOverrideRequestType =
  Requestify<ClearAvatarOverrideRequest>;
export type ClearAvatarOverrideResponseType = AvatarOverrideResponse;
export type ClearAvatarOverrideErrorType = AvatarsRpcError & HubspotMetadata;
export const clearAvatarOverrideRpc: ChirpAvroRpcDetails<
  ClearAvatarOverrideRequestType,
  ClearAvatarOverrideResponseType,
  ClearAvatarOverrideErrorType,
  false
> = {
  serviceName: 'com.hubspot.avatars.rpc.AvatarsRpc',
  rpcName: 'clearAvatarOverride',
  auth: 'app',
  fingerprint: 'czz3M3JpepZxmk2FZ3nHzj5RieILNF9x',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GenerateSignedUriByIdRequestType =
  Requestify<GenerateSignedUriByIdRequest>;
export type GenerateSignedUriByIdResponseType = SignedAvatarUri;
export type GenerateSignedUriByIdErrorType = AvatarsRpcError & HubspotMetadata;
export const generateSignedUriByIdRpc: ChirpAvroRpcDetails<
  GenerateSignedUriByIdRequestType,
  GenerateSignedUriByIdResponseType,
  GenerateSignedUriByIdErrorType,
  false
> = {
  serviceName: 'com.hubspot.avatars.rpc.AvatarsRpc',
  rpcName: 'generateSignedUriById',
  auth: 'app',
  fingerprint: 'a33Q9cxUIjkMHvbV7t9IFj5RieILNF9x',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GenerateSignedUriByUniquePropertyRequestType =
  Requestify<GenerateSignedUriByUniquePropertyRequest>;
export type GenerateSignedUriByUniquePropertyResponseType = SignedAvatarUri;
export type GenerateSignedUriByUniquePropertyErrorType = AvatarsRpcError &
  HubspotMetadata;
export const generateSignedUriByUniquePropertyRpc: ChirpAvroRpcDetails<
  GenerateSignedUriByUniquePropertyRequestType,
  GenerateSignedUriByUniquePropertyResponseType,
  GenerateSignedUriByUniquePropertyErrorType,
  false
> = {
  serviceName: 'com.hubspot.avatars.rpc.AvatarsRpc',
  rpcName: 'generateSignedUriByUniqueProperty',
  auth: 'app',
  fingerprint: '5W4BeOuh5rwMHvbV7t9IFj5RieILNF9x',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GenerateHubspotUserSignedUriRequestType =
  Requestify<GenerateHubspotUserSignedUriRequest>;
export type GenerateHubspotUserSignedUriResponseType = SignedAvatarUri;
export type GenerateHubspotUserSignedUriErrorType = AvatarsRpcError &
  HubspotMetadata;
export const generateHubspotUserSignedUriRpc: ChirpAvroRpcDetails<
  GenerateHubspotUserSignedUriRequestType,
  GenerateHubspotUserSignedUriResponseType,
  GenerateHubspotUserSignedUriErrorType,
  false
> = {
  serviceName: 'com.hubspot.avatars.rpc.AvatarsRpc',
  rpcName: 'generateHubspotUserSignedUri',
  auth: 'app',
  fingerprint: 'hm7eKPSXQZMMHvbV7t9IFj5RieILNF9x',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
